import { StyledTypography } from './styles';

export function ResponsibilityLetterInfo() {
  return (
    <>
      <StyledTypography>
        DECLARA que detém a documentação comprobatória do vínculo trabalhista ou
        estatutário e de parentesco dos beneficiários vinculados ao contrato em
        questão exigido para fins de elegibilidade contratual; e Considerando as
        regras previstas da Lei Geral de proteção de Dados, Lei nº 13.709 de 14
        de agosto de 2018;
      </StyledTypography>
      <StyledTypography>
        DECLARA, para todos os fins de direito, que opta por não compartilhar
        documentos pessoais de seus funcionários e parentes para preservação dos
        dados pessoais, comprometendo-se, neste ato, a observar a elegibilidade
        contratual para inclusão de todo e qualquer beneficiário no plano de
        saúde, enviando as informações e dados necessários para o cadastro dos
        seus beneficiários de acordo com as informações necessárias previstas no
        Contrato e exigidos pela Agência Nacional de Saúde Suplementar – ANS
        como dado obrigatório para manutenção do plano de saúde nos termos da
        legislação correlata e vigente à época da solicitação.
      </StyledTypography>
      <StyledTypography>
        DECLARA, ainda, que, caso solicitado pela Operadora, fornecerá, a
        qualquer tempo e em até 48 horas, a informação e/ou documentos não
        compartilhados ou complementares referentes aos dados cadastrais dos
        Beneficiários, desde que necessários para comprovação do vínculo de
        elegibilidade conforme previsto contratualmente e, exclusivamente para
        esse fim.
      </StyledTypography>
      <StyledTypography>
        DECLARA que assume desde já a responsabilidade por qualquer penalidade
        que a Operadora possa vir a sofrer em razão do descumprimento contratual
        relacionado a este objeto, inclusive quanto à assunção do pagamento
        correspondente à eventual multa da ANS, decorrente da vinculação de
        beneficiário ao contrato em decorrência de falta de elegibilidade
        contratual para este fim, via cobrança complementar e, independente da
        cobranças referentes à contraprestação pecuniária correspondente à
        assistência à saúde em comento.
      </StyledTypography>
      <StyledTypography>
        DECLARA que enviará a documentação comprobatória do Beneficiário visando
        a correção de eventual crítica de movimentação. Esta Declaração tem
        efeitos a partir da vigência do Contrato, e é válida de forma extensiva
        para o contrato principal e suas coligadas, tanto as coligadas já
        existentes quanto as que vierem a ser incorporadas futuramente.
      </StyledTypography>
    </>
  );
}
